import { lazy } from 'react'
import { retry } from '../common/commonFunctions'
import { useRoutes } from 'react-router'

const PortfolioPage = lazy(() => retry(() => import('../pages/PortfolioPage')))
const ProjectDescriptionPage = lazy(() =>
  retry(() => import('../pages/ProjectDescriptionPage')),
)

const Routes = () => {
  const routes = useRoutes([
    {
      path: '/',
      element: <PortfolioPage />,
    },
    {
      path: '/:slug/:pid',
      element: <ProjectDescriptionPage />,
    },
  ])

  return routes
}

export default Routes
